import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text/Text'
import palette from 'core-system/Themes/palette'
import { DashboardPeriod, DashboardProgramCard } from '../dashboardTypes'
import ProgramTypeSections from './ProgramTypeSections'

const EmptyState = styled.div`
  padding: 1.5rem;
  border: 1px dashed ${palette.grey.grey300};
  border-radius: 0.75rem;
  text-align: center;
`

interface ProgramCardsRowProps {
  cards?: DashboardProgramCard[] | null
  isLoading?: boolean
  period?: DashboardPeriod
  onCardClick?: (card: DashboardProgramCard) => void
}

const ProgramCardsRow = ({
  cards = null,
  isLoading = false,
  period = 'all',
  onCardClick,
}: ProgramCardsRowProps) => {
  const showLoading = isLoading || cards === null
  const hasCards = (cards?.length ?? 0) > 0

  if (showLoading) {
    return (
      <EmptyState data-cy='program-cards-row'>
        <Text variant='body1' color={palette.text.secondary}>
          Loading programs…
        </Text>
      </EmptyState>
    )
  }

  if (!hasCards) {
    return (
      <EmptyState data-cy='program-cards-row'>
        <Text variant='body1' color={palette.text.secondary}>
          No active programs yet
        </Text>
      </EmptyState>
    )
  }

  return (
    <ProgramTypeSections
      cards={cards!}
      period={period}
      onCardClick={onCardClick}
    />
  )
}

export default React.memo(ProgramCardsRow)
